import React from 'react';
import TableCell from 'components/organisms/Tables/Table/TableCell';

const TableHead = (props) => {
  return <TableCell {...props} header={true}/>
};

export default TableHead;
